import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { Form } from "./components";

interface CardFieldProps {
  medicationId: number | string;
  name: string;
  label: string;
  value: number | string | null;
  viewValue?: string;
  important?: boolean;
  viewOnly?: boolean;
  textHeight?: string;
}

const CardField: React.FC<CardFieldProps> = ({
  medicationId,
  name,
  label,
  value,
  viewValue,
  important = false,
  viewOnly = false,
  textHeight = "32px"
}) => {
  const [edit, setEdit] = React.useState(false);

  return (
    <Box
      flex="1 1"
      p={2}
      bg={important ? "gray.100" : "initial"}
      borderRadius="xl"
      boxShadow="base"
      w="min-content"
    >
      <Text
        color="black"
        fontSize="sm"
        fontWeight="semibold"
        lineHeight={5}
        p={1}
        whiteSpace="nowrap"
      >
        {label}
      </Text>
      {edit && !important && !viewOnly ? (
        <Box mt={1}>
          <Form
            medicationId={medicationId}
            fieldName={name}
            value={value}
            onFinish={() => setEdit(false)}
          />
        </Box>
      ) : (
        <Text
          onClick={() => setEdit(true)}
          mt={1}
          color="black"
          border="1px solid transparent"
          borderRadius="base"
          p="5px 4px 4px 4px"
          display="flex"
          alignItems="center"
          lineHeight="21px"
          h={textHeight}
          {...(!important &&
            !viewOnly && {
              transition: "background linear 100ms",
              cursor: "pointer",
              _hover: { background: "gray.100" }
            })}
        >
          {viewValue || value || "-"}
        </Text>
      )}
    </Box>
  );
};

export default CardField;
